"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initDownloadPostboxDocument = exports.getPostboxDocuments = void 0;
var _mainConfig = require("../mainConfig");
var _postboxApi = _interopRequireDefault(require("../csc/api/postboxApi"));
var _postboxApi2 = _interopRequireDefault(require("../cic/api/postboxApi"));
var _ref = _mainConfig.isCICContentTree ? _postboxApi2.default : _postboxApi.default,
  initDownloadPostboxDocument = exports.initDownloadPostboxDocument = _ref.initDownloadPostboxDocument,
  getPostboxDocuments = exports.getPostboxDocuments = _ref.getPostboxDocuments;